// extracted by mini-css-extract-plugin
export default {"modal":"answer-quotation-modal_modal__tX9gM","content":"answer-quotation-modal_content__U04Zb"};